/**
 * AmazingThing homepage landing interactions
 * Gallery snap/dots/play, reveal .rv, craft scrub, stats countUp, rail, auto videos
 */
(function () {
  'use strict';

  var reduced = false;
  try {
    reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  /* Video önceliği: önce banner (highlights) ilk videosu. Diğer tüm videolar bu kapı açılınca yüklenir.
     Kapı; banner ilk videosu 'canplay' olunca veya en geç 4 sn sonra açılır. */
  var hlGateOpen = false;
  var hlGateQueue = [];
  function afterHl(fn) {
    if (hlGateOpen) fn();
    else hlGateQueue.push(fn);
  }
  function openHlGate() {
    if (hlGateOpen) return;
    hlGateOpen = true;
    hlGateQueue.splice(0).forEach(function (fn) {
      try {
        fn();
      } catch (e) {}
    });
  }
  setTimeout(openHlGate, 4000);

  /* Reveal */
  var rvEls = document.querySelectorAll('.at-land .rv, .rv');
  if (reduced) {
    rvEls.forEach(function (el) {
      el.classList.add('in');
    });
  } else if (rvEls.length && 'IntersectionObserver' in window) {
    var rio = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            rio.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    rvEls.forEach(function (el) {
      rio.observe(el);
    });
  }

  /* Auto-play videos in view — highlights galeri videolarını (data-gal) HARİÇ tut;
     onlar tek-aktif-video mantığıyla aşağıda yönetilir (çift play = donma). */
  var autoVids = document.querySelectorAll('video[data-auto]:not([data-gal])');
  autoVids.forEach(function (v) {
    v.removeAttribute('autoplay');
    v.autoplay = false;
  });
  if (!reduced && autoVids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          var v = e.target;
          v._atInView = e.isIntersecting;
          if (e.isIntersecting) {
            if (!v.dataset.user) {
              afterHl(function () {
                if (!v._atInView) return;
                v.preload = 'auto';
                v.play().catch(function () {});
              });
            }
          } else {
            v.pause();
          }
        });
      },
      { threshold: 0.35 }
    );
    /* Yaklaşınca arabelleğe al (oynatmadan) */
    var vpre = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var v = e.target;
          vpre.unobserve(v);
          afterHl(function () {
            if (v.preload !== 'auto') {
              v.preload = 'auto';
              if (v.readyState < 1) {
                try {
                  v.load();
                } catch (err) {}
              }
            }
          });
        });
      },
      { rootMargin: '400px 0px 400px 0px' }
    );
    autoVids.forEach(function (v) {
      vio.observe(v);
      vpre.observe(v);
    });
  }

  /* Craft scrub */
  var craftMedia = document.getElementById('craftMedia');
  var ticking = false;

  function updateCraftScrub() {
    if (!craftMedia) return;
    if (reduced) {
      craftMedia.style.opacity = '1';
      craftMedia.style.transform = 'none';
      return;
    }
    var r = craftMedia.getBoundingClientRect();
    var vh = window.innerHeight;
    var entry = vh;
    var exit = vh * 0.22;
    var p = Math.min(1, Math.max(0, (entry - r.top) / (entry - exit)));
    var rotate = -20 * (1 - p);
    var y = 110 * (1 - p);
    var scale = 0.9 + 0.1 * p;
    craftMedia.style.opacity = (0.15 + 0.85 * p).toFixed(3);
    craftMedia.style.transform =
      'translateY(' + y.toFixed(1) + 'px) rotateX(' + rotate.toFixed(2) + 'deg) scale(' + scale.toFixed(3) + ')';
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateCraftScrub();
      ticking = false;
    });
  }

  if (craftMedia) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateCraftScrub);
    updateCraftScrub();
  }

  /* Stats countUp */
  var statEls = document.querySelectorAll('.stat-num[data-count]');
  function countUp(el) {
    var target = +el.dataset.count;
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var t0 = null;
    var dur = 1300;
    function frame(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(target * e) + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  if (!reduced && statEls.length && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            countUp(e.target);
            sio.unobserve(e.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    statEls.forEach(function (el) {
      sio.observe(el);
    });
  } else if (reduced) {
    statEls.forEach(function (el) {
      var prefix = el.dataset.prefix || '';
      var suffix = el.dataset.suffix || '';
      el.textContent = prefix + el.dataset.count + suffix;
    });
  }

  /* Gallery */
  var hlSec = document.getElementById('hlSec') || document.querySelector('[data-at-hl]');
  var track = document.getElementById('hlTrack');
  var dotsEl = document.getElementById('hlDots');
  var playBtn = document.getElementById('hlPlay');
  var watchFilm2 = document.getElementById('watchFilm2');

  var gi = 0;
  var gTimer = null;
  var gPlaying = true;
  var gEnded = false;
  var hlVisible = false;
  var cards = [];
  var dots = [];
  var galVids = [];

  function setBtn(state) {
    if (!playBtn) return;
    playBtn.dataset.state = state;
    playBtn.setAttribute(
      'aria-label',
      state === 'playing' ? 'Galeriyi duraklat' : state === 'paused' ? 'Galeriyi oynat' : 'Galeriyi baştan başlat'
    );
  }

  function goTo(i) {
    if (!track || !cards.length) return;
    i = Math.max(0, Math.min(cards.length - 1, i));
    var c = cards[i];
    track.scrollTo({
      left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2,
      behavior: reduced ? 'auto' : 'smooth',
    });
  }

  function activeIndex() {
    if (!track || !cards.length) return 0;
    var center = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bd = Infinity;
    cards.forEach(function (c, i) {
      var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
      if (d < bd) {
        bd = d;
        best = i;
      }
    });
    return best;
  }

  function getCardVideo(c) {
    return c ? c.querySelector('video[data-gal]') : null;
  }

  function cardDuration(c) {
    if (!c) return 7000;
    var d = parseInt(c.getAttribute('data-duration') || '', 10);
    return d > 0 ? d : 7000;
  }

  function clearVideoEnd(v) {
    if (!v || !v._hlOnEnd) return;
    v.removeEventListener('ended', v._hlOnEnd);
    v._hlOnEnd = null;
  }

  function clearVideoReady(v) {
    if (!v || !v._hlOnReady) return;
    v.removeEventListener('canplaythrough', v._hlOnReady);
    v.removeEventListener('canplay', v._hlOnReady);
    v.removeEventListener('loadeddata', v._hlOnReady);
    v._hlOnReady = null;
  }

  function resetGalleryVideo(v) {
    if (!v) return;
    clearVideoEnd(v);
    clearVideoReady(v);
    if (!v.paused) {
      try {
        v.pause();
      } catch (e) {}
    }
    try {
      v.currentTime = 0;
    } catch (e) {}
  }

  /* 2026-10-11: mobilde bölüm ilk ekranın altındaysa galeri videoları bölüme yaklaşınca yüklenir (mobil veri / hız) */
  var hlDefer = false;
  var hlPending = [];
  function armVideo(v) {
    if (!v) return;
    if (hlDefer) {
      if (hlPending.indexOf(v) < 0) hlPending.push(v);
      return;
    }
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.loop = false;
    v.removeAttribute('loop');
    v.removeAttribute('autoplay');
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    if (v.preload !== 'auto') {
      v.preload = 'auto';
      /* load() yalnızca hiç veri yoksa — aksi halde buffer sıfırlanır, takılma yapar */
      if (v.readyState < 2) {
        try {
          v.load();
        } catch (e) {}
      }
    }
  }

  function playVideo(v) {
    if (!v || reduced) return;
    armVideo(v);
    clearVideoReady(v);
    var restarting = v.ended || v.currentTime < 0.05;
    if (restarting) {
      try {
        v.currentTime = 0;
      } catch (e) {}
    }
    var tryPlay = function () {
      if (!v.paused && !v.ended && v.readyState >= 2) return;
      var p = v.play();
      if (p && typeof p.then === 'function') p.catch(function () {});
    };
    if (v.readyState >= 3) {
      tryPlay();
    } else if (v.readyState >= 2) {
      tryPlay();
    } else {
      var onReady = function () {
        clearVideoReady(v);
        tryPlay();
      };
      v._hlOnReady = onReady;
      v.addEventListener('canplaythrough', onReady, { once: true });
      v.addEventListener('canplay', onReady, { once: true });
    }
  }

  function pauseVideo(v) {
    resetGalleryVideo(v);
  }

  function prefetchAdjacent(i) {
    var cur = getCardVideo(cards[i]);
    var go = function () {
      var next = getCardVideo(cards[i + 1]);
      var prev = getCardVideo(cards[i - 1]);
      if (next) armVideo(next);
      if (prev) armVideo(prev);
    };
    if (!cur || cur.readyState >= 4) go();
    else cur.addEventListener('canplaythrough', go, { once: true });
  }

  function advanceFrom(i) {
    if (!gPlaying || gEnded || !hlVisible) return;
    if (i !== gi) return;
    stopTimer();
    if (gi < cards.length - 1) {
      goTo(gi + 1);
    } else {
      gEnded = true;
      setBtn('ended');
    }
  }

  function stopTimer() {
    clearTimeout(gTimer);
    gTimer = null;
    galVids.forEach(clearVideoEnd);
  }

  /* Video slayt: clip bitene kadar bekle. Diğerleri: data-duration (varsayılan 7s). */
  function startTimer() {
    stopTimer();
    if (reduced || !gPlaying || gEnded || !hlVisible || !cards.length) return;
    if (gi >= cards.length - 1) {
      gEnded = true;
      setBtn('ended');
      return;
    }

    var card = cards[gi];
    var v = getCardVideo(card);

    if (v) {
      var onEnd = function () {
        clearVideoEnd(v);
        clearTimeout(gTimer);
        gTimer = null;
        advanceFrom(gi);
      };
      v._hlOnEnd = onEnd;
      v.addEventListener('ended', onEnd);

      var armSafety = function () {
        var dur = v.duration;
        if (!isFinite(dur) || dur <= 0) dur = 18;
        var ms = Math.min(Math.max(dur * 1000 + 400, 8000), 45000);
        gTimer = setTimeout(function () {
          advanceFrom(gi);
        }, ms);
      };
      if (isFinite(v.duration) && v.duration > 0) {
        armSafety();
      } else {
        v.addEventListener(
          'loadedmetadata',
          function onceMeta() {
            v.removeEventListener('loadedmetadata', onceMeta);
            if (gPlaying && !gEnded && hlVisible) armSafety();
          },
          { once: true }
        );
        gTimer = setTimeout(function () {
          advanceFrom(gi);
        }, 20000);
      }
      return;
    }

    gTimer = setTimeout(function () {
      advanceFrom(gi);
    }, cardDuration(card));
  }

  function setActive(i) {
    gi = i;
    dots.forEach(function (d, k) {
      d.classList.toggle('on', k === i);
    });
    cards.forEach(function (c, k) {
      c.classList.toggle('is-active', k === i);
      var layers = c.querySelector('[data-layers]');
      if (layers && k !== i && !layers.hasAttribute('data-layers-always-open')) {
        setLayersOpen(layers, false);
      }
      var v = getCardVideo(c);
      if (!v) return;
      if (k === i && gPlaying && hlVisible && !reduced) {
        playVideo(v);
      } else {
        resetGalleryVideo(v);
      }
    });
    prefetchAdjacent(i);
    var activeCard = cards[i];
    if (activeCard) {
      var activeLayers = activeCard.querySelector('[data-layers-always-open]');
      if (activeLayers) drawLayersCallouts(activeLayers);
    }
    if (i === cards.length - 1) {
      gEnded = true;
      stopTimer();
      setBtn('ended');
      return;
    }
    if (gEnded) {
      gEnded = false;
      setBtn(gPlaying ? 'playing' : 'paused');
    }
    if (gPlaying && hlVisible && !reduced) startTimer();
    else stopTimer();
  }

  function drawLayersCallouts(root) {
    if (!root) return;
    var list = root.querySelector('.hl-layers__callouts');
    if (!list) return;
    root.classList.add('is-animating');
    list.querySelectorAll('.hl-layers__callout-line-svg').forEach(function (svg) {
      svg.classList.remove('is-drawn');
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        list.querySelectorAll('.hl-layers__callout-line-svg').forEach(function (svg) {
          svg.classList.add('is-drawn');
        });
        root.classList.remove('is-animating');
      });
    });
  }

  function setLayersOpen(root, open) {
    if (!root) return;
    if (root.hasAttribute('data-layers-always-open')) {
      if (open) drawLayersCallouts(root);
      return;
    }
    var plus = root.querySelector('[data-layers-plus]');
    var list = root.querySelector('.hl-layers__callouts');
    root.classList.toggle('is-open', open);
    if (plus) {
      plus.setAttribute('aria-expanded', open ? 'true' : 'false');
      plus.setAttribute('aria-label', open ? 'Katman detaylarını gizle' : 'Katman detaylarını göster');
    }
    if (list) {
      if (open) {
        drawLayersCallouts(root);
        list.removeAttribute('hidden');
      } else {
        list.setAttribute('hidden', '');
        list.querySelectorAll('.hl-layers__callout-line-svg').forEach(function (svg) {
          svg.classList.remove('is-drawn');
        });
      }
    }
  }

  function userInterrupt() {
    /* Elle kaydırınca süreyi aktif slayta göre yeniden kur */
    if (gPlaying && !gEnded && hlVisible) startTimer();
    else stopTimer();
  }

  if (track && dotsEl && playBtn) {
    track.scrollLeft = 0;
    cards = Array.prototype.slice.call(track.querySelectorAll('.hl-figure'));
    galVids = track.querySelectorAll('video[data-gal]');

    var firstGal = galVids[0];
    if (
      firstGal &&
      hlSec &&
      'IntersectionObserver' in window &&
      window.matchMedia &&
      window.matchMedia('(max-width: 740px)').matches &&
      hlSec.getBoundingClientRect().top > window.innerHeight
    ) {
      hlDefer = true;
      var hlNear = new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            hlNear.disconnect();
            hlDefer = false;
            hlPending.splice(0).forEach(armVideo);
          });
        },
        { rootMargin: '300px 0px' }
      );
      hlNear.observe(hlSec);
    }
    if (firstGal && !hlDefer) {
      if (firstGal.readyState >= 3) openHlGate();
      else firstGal.addEventListener('canplay', openHlGate, { once: true });
    } else {
      openHlGate();
    }

    galVids.forEach(function (v, idx) {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.loop = false;
      v.removeAttribute('loop');
      v.removeAttribute('autoplay');
      if (idx === 0) {
        armVideo(v);
      } else {
        v.preload = 'none';
      }
    });

    cards.forEach(function (c, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'hl-dot' + (i === 0 ? ' on' : '');
      d.setAttribute('role', 'tab');
      d.setAttribute('aria-label', 'Kart ' + (i + 1));
      d.addEventListener('click', function () {
        goTo(i);
      });
      dotsEl.appendChild(d);
    });
    dots = dotsEl.querySelectorAll('.hl-dot');
    setBtn('playing');
    setActive(0);
    goTo(0);

    track.querySelectorAll('[data-layers-always-open]').forEach(function (root) {
      drawLayersCallouts(root);
    });

    track.querySelectorAll('[data-layers-plus]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var root = btn.closest('[data-layers]');
        if (!root) return;
        var open = !root.classList.contains('is-open');
        setLayersOpen(root, open);
        if (open) {
          gPlaying = false;
          stopTimer();
          setBtn('paused');
        }
      });
    });

    ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
      track.addEventListener(ev, userInterrupt, { passive: true });
    });

    var scrollDeb = null;
    var lastActive = -1;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollDeb);
        scrollDeb = setTimeout(function () {
          var next = activeIndex();
          if (next === lastActive) return;
          lastActive = next;
          setActive(next);
        }, 120);
      },
      { passive: true }
    );

    playBtn.addEventListener('click', function () {
      if (gEnded) {
        gEnded = false;
        gPlaying = true;
        setBtn('playing');
        goTo(0);
      } else if (gPlaying) {
        gPlaying = false;
        stopTimer();
        setBtn('paused');
        galVids.forEach(pauseVideo);
      } else {
        gPlaying = true;
        setBtn('playing');
        setActive(gi);
      }
    });

    if (hlSec && 'IntersectionObserver' in window) {
      var hio = new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            hlVisible = e.isIntersecting;
            if (hlVisible) {
              lastActive = -1;
              setActive(activeIndex());
            } else {
              stopTimer();
              galVids.forEach(pauseVideo);
            }
          });
        },
        { threshold: 0.25 }
      );
      hio.observe(hlSec);
    } else {
      hlVisible = true;
      setActive(0);
    }
  }

  if (!track || !galVids.length) openHlGate();

  if (watchFilm2) {
    watchFilm2.addEventListener('click', function (ev) {
      if (watchFilm2.tagName === 'BUTTON' || !watchFilm2.getAttribute('href') || watchFilm2.getAttribute('href') === '#') {
        ev.preventDefault();
      }
      if (hlSec) {
        hlSec.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      }
      gPlaying = true;
      setBtn('playing');
      goTo(0);
      startTimer();
    });
  }

  /* Showcase rail */
  var rail = document.getElementById('rail');
  var prev = document.getElementById('railPrev');
  var next = document.getElementById('railNext');

  if (rail && prev && next) {
    function railStep() {
      var c = rail.querySelector('.rail-card');
      return c ? c.offsetWidth + 16 : 300;
    }
    function railUpdate() {
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
    }
    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -railStep(), behavior: reduced ? 'auto' : 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: railStep(), behavior: reduced ? 'auto' : 'smooth' });
    });
    rail.addEventListener(
      'scroll',
      function () {
        requestAnimationFrame(railUpdate);
      },
      { passive: true }
    );
    window.addEventListener('resize', railUpdate);
    railUpdate();
  }

  /* Showcase video cards — viewport autoplay, video-only (no stale poster images) */
  var railVideoCards = document.querySelectorAll('[data-rail-video-card]');
  if (railVideoCards.length) {
    var hoverPlay = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var railEl = document.getElementById('rail');

    function markReady(card) {
      card.classList.add('is-ready');
    }

    function primeVideo(video) {
      if (!video || video.readyState >= 2) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        var done = function () {
          video.removeEventListener('loadeddata', done);
          video.removeEventListener('canplay', done);
          resolve();
        };
        video.addEventListener('loadeddata', done, { once: true });
        video.addEventListener('canplay', done, { once: true });
        try {
          video.load();
        } catch (_) {
          resolve();
        }
      });
    }

    function preloadNearbyCards() {
      if (!railEl) return;
      var railRect = railEl.getBoundingClientRect();
      var margin = Math.max(railRect.width * 0.5, 240);
      railVideoCards.forEach(function (card) {
        var rect = card.getBoundingClientRect();
        if (rect.right < railRect.left - margin || rect.left > railRect.right + margin) return;
        var video = card.querySelector('video');
        if (!video) return;
        primeVideo(video).then(function () {
          markReady(card);
        });
      });
    }

    function setPlaying(card, playing) {
      card.classList.toggle('is-playing', !!playing);
    }

    function playCard(card) {
      var video = card.querySelector('video');
      if (!video) return;
      primeVideo(video).then(function () {
        markReady(card);
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.then(function () {
            setPlaying(card, true);
          }).catch(function () {});
        } else {
          setPlaying(card, true);
        }
      });
    }

    function pauseCard(card) {
      var video = card.querySelector('video');
      if (!video) return;
      video.pause();
      setPlaying(card, false);
    }

    railVideoCards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;

      video.addEventListener(
        'loadeddata',
        function () {
          markReady(card);
        },
        { once: true }
      );

      if (hoverPlay) {
        card.addEventListener('mouseenter', function () {
          playCard(card);
        });
        card.addEventListener('mouseleave', function () {
          pauseCard(card);
        });
        card.addEventListener('focusin', function () {
          playCard(card);
        });
        card.addEventListener('focusout', function () {
          pauseCard(card);
        });
      }
    });

    var railStarted = false;
    function startRailVideos() {
      if (railStarted) return;
      railStarted = true;
    if (railEl) {
      railEl.addEventListener('scroll', preloadNearbyCards, { passive: true });
    }
    preloadNearbyCards();

    if ('IntersectionObserver' in window) {
      var railIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var card = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              playCard(card);
            } else {
              pauseCard(card);
            }
          });
        },
        { threshold: [0, 0.35, 0.6, 1], root: railEl || null, rootMargin: '0px 80px 0px 80px' }
      );
      railVideoCards.forEach(function (card) {
        railIo.observe(card);
      });
    } else {
      railVideoCards.forEach(function (card) {
        playCard(card);
      });
    }
    }

    var railHost = railEl || railVideoCards[0];
    if (railHost && 'IntersectionObserver' in window) {
      var railNearIo = new IntersectionObserver(
        function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) {
              railNearIo.disconnect();
              afterHl(startRailVideos);
            }
          });
        },
        { rootMargin: '500px 0px 500px 0px' }
      );
      railNearIo.observe(railHost);
    } else {
      afterHl(startRailVideos);
    }
  }
})();
